import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

export interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'RadioGroup',
})(
  (
    { brandColors, spacing, breakpoints, type, typography: { pxToRem } },
    props
  ) => ({
    inputContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    label: {
      ...type['16_medium'],
      paddingLeft: pxToRem(16),
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
    },
    fieldset: { border: 0, padding: 0, margin: 0 },
    legend: {
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
      marginBottom: pxToRem(16),
      ...type['16_medium'],
      [breakpoints.up('sm')]: {
        ...type['18_medium'],
      },
      [breakpoints.up('lg')]: {
        ...type['20_medium'],
      },
    },
    legendSmall: {
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
      marginBottom: pxToRem(16),
      ...type['14_medium'],
    },
    radio: {
      marginRight: spacing(1),
      display: 'flex',
      alignItems: 'center',
    },
    radioInput: {
      margin: 0,
      border: 0,
      width: pxToRem(20),
      height: pxToRem(20),
      '&:not(:checked)': {
        appearance: 'none',
        backgroundColor: darkOrLightStyle(props)(
          brandColors.tintsHeroBlue20,
          brandColors.white
        ),
        borderRadius: '20px',
        border: `0.5px solid ${brandColors.lightGray}`,
      },
      accentColor: darkOrLightStyle(props)(
        brandColors.white,
        brandColors.black
      ),
    },
    radioButtonsContainer: {
      display: 'flex',
      marginBottom: pxToRem(10),
    },
  })
);

export default useStyles;
